import './StyledItem.scss';

export { default } from './StyledItem';
